import { z } from 'zod'
import { ReviewOutputSchema } from './sessionReviewers'

export const MonitoringStatusSchema = z.object({
  configured: z.boolean(), enabled: z.boolean(), has_sessions: z.boolean(),
  timezone: z.string(), latest_run_id: z.string().nullable(), can_edit: z.boolean(),
})
const MonitoringReviewSchema = z.object({
  id: z.string(), reviewer: z.string(), status: z.string(), latest_status: z.string(), latest_id: z.string(),
  output: ReviewOutputSchema.nullable(), journey_id: z.string().nullable(),
})
export const MonitoringSessionsSchema = z.object({
  sessions: z.array(z.object({
    session_id: z.string(), external_session_url: z.string(), first_received_at: z.string(),
    user_email: z.string().nullable(), journey_id: z.string().nullable(), journey_status: z.string().nullable(),
    reviews: z.array(MonitoringReviewSchema),
  })),
  total: z.number().int().nonnegative(), page: z.number().int().nonnegative(), has_more: z.boolean(), can_edit: z.boolean(),
})
export const MonitoringPageSchema = z.coerce.number().int().min(0).max(100000)
